export default {
    applicationAccessList: {},
    applicationAccessFields: [
        {
            key: 'title',
            label: 'Application Title',
            sortable: true,
        },
        // {
        //     key: 'domain',
        //     label: 'Domain',
        //     sortable: true,
        // },
        {
            key: 'bundleId',
            label: 'Bundle Id',
            sortable: true,
        },
        {
            key: 'device',
            label: 'device',
            sortable: true,
        },
        {
            key: 'codeKey',
            label: 'Code Key',
            sortable: true,
        },
        {
            key: 'status',
            label: 'Status',
            sortable: true,
            class: 'text-center status-absolute-pos',
        },
        {
            key: 'action',
            label: 'Action',
            tdClass: 'user-roles-action',
        },
    ],
}
